import {
  SideBarStudentItem,
  StudentSideBarItemType,
} from './componenets/side-bar-student-item';
import React from 'react';
import './componenets/side-bar-lecturer.css';

export interface SideBarLecturerModel {
  onClick: (type: StudentSideBarItemType) => void;
}

export const SideBarLecturer: React.FC<SideBarLecturerModel> = ({
  onClick,
}) => {
  return (
    <div className="lecturer-sidebar">
      <div className="sidebar-section">
        <h3 className="section-title">מידע אישי</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.PROFILE}
          text={'פרטים אישיים'}
          onClick={onClick}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">לימודים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.LECTURES}
          text={'מפגשים'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.EXAMS}
          text={'מבחנים'}
          onClick={onClick}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.ASSIGNMENTS}
          text={'מטלות'}
          onClick={onClick}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">מידע פיננסי</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.RATES}
          text={'תעריפים'}
          onClick={onClick}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">מסמכים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.DOCS}
          text={'מסמכים'}
          onClick={onClick}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">שעות עבודה</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.WORKING_HOURS}
          text={'שעות עבודה'}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
